<template>
  <svg role="presentation"
       :class="iconClass">
    <use :xlink:href="'#' + icons[icon].id" />
  </svg>
</template>

<script>
  /* icons */
  import deleteIcon from "@/assets/icons/ic_delete_24px.svg?sprite"
  import search from "@/assets/icons/search.svg?sprite"
  import birthday from "@/assets/icons/baby-buggy.svg?sprite"
  import add from '@/assets/icons/add.svg?sprite'
  import listOs from '@/assets/icons/list-os.svg?sprite'
  import cardOs from '@/assets/icons/card-os.svg?sprite'
  import close from '@/assets/icons/close.svg?sprite'
  import pencil from '@/assets/icons/pencil.svg?sprite'
  import nascimento from '@/assets/icons/nascimento.svg?sprite'
  import book from '@/assets/icons/book-open-variant.svg?sprite'
  import engagement from '@/assets/icons/engagement.svg?sprite'
  import flower from '@/assets/icons/flower.svg?sprite'
  import image from "@/assets/icons/file-image.svg?sprite"
  import note from "@/assets/icons/note.svg?sprite"
  import dolar from "@/assets/icons/dolar.svg?sprite"
  import print from "@/assets/icons/print.svg?sprite"
  import trash from "@/assets/icons/trash.svg?sprite"
  import zoomMinus from "@/assets/icons/zoom-minus.svg?sprite"
  import zoomPlus from "@/assets/icons/zoom-plus.svg?sprite"
  import arrowDown from "@/assets/icons/arrow-down.svg?sprite"
  import arrowRight from "@/assets/icons/arrow-right.svg?sprite"
  import arrowLeft from "@/assets/icons/arrow-left.svg?sprite"
  import folderOpen from "@/assets/icons/folder-open.svg?sprite"
  import fileUpload from "@/assets/icons/file-upload.svg?sprite"
  import fileDownload from "@/assets/icons/file-download.svg?sprite"
  import contactSupport from "@/assets/icons/contact_support-black-18dp.svg?sprite"
  import helpCircle from "@/assets/icons/help-circle.svg?sprite"
  import hourIcon from "@/assets/icons/update-hour.svg?sprite"
  import cloudDownload from "@/assets/icons/cloud-download.svg?sprite"
  import cloudSync from "@/assets/icons/cloud-sync.svg?sprite"
  import cloudSyncRed from "@/assets/icons/cloud-sync-nok.svg?sprite"
  import cloudSyncCheck from "@/assets/icons/cloud-check.svg?sprite"
  import arrowDecision from "@/assets/icons/arrow-decision.svg?sprite"
  import arrowBoldUp from "@/assets/icons/arrow-up-bold.svg?sprite"
  import arrowBoldDown from "@/assets/icons/arrow-down-bold.svg?sprite"
  import mapMarker from "@/assets/icons/map-marker.svg?sprite"
  import done from "@/assets/icons/done-24px.svg?sprite"
  import close2 from "@/assets/icons/close-24px.svg?sprite"
  import eraser from "@/assets/icons/eraser-variant.svg?sprite"
  import check from "@/assets/icons/check_circle-24px.svg?sprite"
  import error from "@/assets/icons/error-24px.svg?sprite"
  import alert from "@/assets/icons/warning-24px.svg?sprite"
  import location from "@/assets/icons/gps_fixed-24px.svg?sprite"
  import ribbon from "@/assets/icons/ribbon.svg?sprite"
  import calendar from "@/assets/icons/calendar-heart.svg?sprite"
  import boxPlus from "@/assets/icons/text_box_plus.svg?sprite"
  import fileEye from "@/assets/icons/file-eye-outline.svg?sprite"
  import deleteForever from "@/assets/icons/delete_forever_24px.svg?sprite"
  import calendarAlert from "@/assets/icons/calendar-alert.svg?sprite"
  import send from "@/assets/icons/send-24px.svg?sprite"
  import clipboard from "@/assets/icons/clipboard-check-outline.svg?sprite"
  import sofiaLogo from "@/assets/icons/logo-sofia.svg?sprite"
  import sofiaLogoWhite from "@/assets/icons/logo-sofia-white.svg?sprite"
  import duplaEsquerda from "@/assets/icons/chevron-double-left.svg?sprite"
  import esquerda from "@/assets/icons/chevron-left.svg?sprite"
  import direita from "@/assets/icons/chevron-right.svg?sprite"
  import duplaDireita from "@/assets/icons/chevron-double-right.svg?sprite"
  import crcLogoPrincipal from "@/assets/icons/CRC-logo_principal.svg?sprite"
  import bryTecnologiaLogo from "@/assets/icons/bry-tecnologia-logo.svg?sprite"
  import familyTree from "@/assets/icons/family-tree.svg?sprite"
  import fileDocumentEdit from "@/assets/icons/file-document-edit.svg?sprite"
  import touch from "@/assets/icons/touch_app_black_24dp.svg?sprite"
  import qrcode from "@/assets/icons/qrcode.svg?sprite"
  import accountGroup from "@/assets/icons/group_black_24dp.svg?sprite"
  import simplePencil from "@/assets/icons/simple-pencil.svg?sprite"
  import airplane from "@/assets/icons/file-aeroplan.svg?sprite"
  import pending from "@/assets/icons/pending_black_48dp.svg?sprite"
  import sofiaWhite from "@/assets/icons/logo-sofia-white.svg?sprite"
  import copy from "@/assets/icons/copy-solid.svg?sprite"
  import cancel from "@/assets/icons/cancel.svg?sprite"
  import imagePlusWhite from '@/assets/icons/image-plus-white.svg?sprite'
  import eye from "@/assets/icons/eye.svg?sprite"
  import textSnippet from "@/assets/icons/text_snippet_black_24dp.svg?sprite"
  import ServicosRealizados from "@/assets/icons/servicos-realizados.svg?sprite"
  import dotsHorizontalCircle from "@/assets/icons/dots-horizontal-circle.svg?sprite"
  import clockTimeFour from "@/assets/icons/clock-time-four.svg?sprite"
  import closeCircle from "@/assets/icons/close-circle.svg?sprite"
  import requerimentoSemPendencia from "@/assets/icons/requerimento-sem-pendencia.svg?sprite"
  import requerimentoComPendencia from "@/assets/icons/requerimento-com-pendencia.svg?sprite"
  import openInNew from "@/assets/icons/open_in_new.svg?sprite"

  export default {
    name: "IconSvg",
    props: {
      icon: String,
      iconClass: String
    },
    data () {
      return {
        icons: {
          deleteIcon,
          search,
          birthday,
          add,
          listOs,
          cardOs,
          close,
          pencil,
          flower,
          engagement,
          nascimento,
          book,
          image,
          note,
          dolar,
          print,
          trash,
          zoomMinus,
          zoomPlus,
          arrowDown,
          arrowRight,
          arrowLeft,
          folderOpen,
          fileUpload,
          fileDownload,
          cloudSync,
          cloudSyncRed,
          cloudSyncCheck,
          contactSupport,
          helpCircle,
          hourIcon,
          cloudDownload,
          arrowDecision,
          arrowBoldUp,
          arrowBoldDown,
          mapMarker,
          done,
          close2,
          eraser,
          check,
          error,
          alert,
          location,
          calendar,
          ribbon,
          boxPlus,
          fileEye,
          deleteForever,
          calendarAlert,
          send,
          clipboard,
          sofiaLogo,
          sofiaLogoWhite,
          duplaEsquerda,
          esquerda,
          direita,
          duplaDireita,
          crcLogoPrincipal,
          bryTecnologiaLogo,
          familyTree,
          fileDocumentEdit,
          touch,
          qrcode,
          accountGroup,
          simplePencil,
          airplane,
          pending,
          sofiaWhite,
          copy,
          cancel,
          imagePlusWhite,
          eye,
          textSnippet,
          ServicosRealizados,
          dotsHorizontalCircle,
          clockTimeFour,
          closeCircle,
          requerimentoSemPendencia,
          requerimentoComPendencia,
          openInNew
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../scss/_components/resumos';
</style>
